import React from "react";
import { Box, CardMedia, Stack, Typography, useTheme } from "@mui/material";
import { EGButton } from "../../../../../MainComponents/Button/EGButton/EGButton";
import EthiquinIntereviewer from "../../../../../../assets/images/Ethiquin/IAInterview.svg";
import { WaveBG } from "../../../../../AI/TitleAnimation/WaveBG";
import { useTranslation } from "react-i18next";

export const InterviewActions = ({ onEdit, onApply, status }) => {
  const [t] = useTranslation("investigation");
  const theme = useTheme();

  // Diccionario de acciones según status
  const actionsByStatus = {
    pending: [
      {
        label: t("Interview.edit_interview"),
        iconName: "outline_message_edit",
        onClick: onEdit,
        labelColor: "teal",
        iconColor: "teal",
        iconColorHover: "tealII",
      },
      {
        label: t("Interview.begin_interview"),
        iconName: "outline_message_text_2",
        onClick: onApply,
        labelColor: "cobalt",
        iconColor: "cobalt",
        iconColorHover: "cobalt",
      },
    ],
    process: [
      {
        label: t("Interview.continue_interview"),
        iconName: "outline_message_text_2",
        onClick: onApply,
        labelColor: "cobalt",
        iconColor: "cobalt",
        iconColorHover: "cobalt",
      },
    ],
  };

  const currentActions = actionsByStatus[status] || [];

  return (
    <Box sx={{ zIndex: theme.zIndex.modal + 1 }}>
      <Typography variant="h6" gutterBottom textAlign="center">
        <WaveBG fullScreen={true} waveCount={8} />
        <CardMedia
          component="img"
          src={EthiquinIntereviewer}
          alt="Interview saved"
          sx={{
            width: { xs: "95%", md: 450 },
            height: "auto",
            mx: "auto",
            my: 2,
            userSelect: "none",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
            WebkitTouchCallout: "none",
            WebkitUserDrag: "none",
          }}
        />
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "center",
            flexFlow: "row wrap",
            mx: "auto",
          }}
          spacing={{ xs: 2, md: 4 }}
        >
          {currentActions.map((action, index) => (
            <EGButton
              key={index}
              iconName={action.iconName}
              label={action.label}
              onClick={action.onClick}
              labelColor={action.labelColor}
              iconColor={action.iconColor}
              iconColorHover={action.iconColorHover}
              disableElevation={false}
              size="medium"
            />
          ))}
        </Stack>
      </Typography>
    </Box>
  );
};
